import { render, staticRenderFns } from "./ContactWay.vue?vue&type=template&id=a4b2a4d8"
import script from "./ContactWay.vue?vue&type=script&lang=js"
export * from "./ContactWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports